import { Typography } from 'antd'
import React, { useContext } from 'react'
import styled from 'styled-components';
import { HistoryContext } from '../../HistoryContextContainer';
import { useTranslation } from 'react-i18next';

interface IProps {
    areaSizeInHectares: number | undefined,
    groupedStatistics: any
}

const AreaByNotificationTypeContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const StatisticsTableHeader = styled.th`
    text-align: left;
`;

const sortingFn = (feature1: any, feature2: any) => {
    if (feature1.sumArea < feature2.sumArea) {
        return 1;
    }
    else if (feature1.sumArea > feature2.sumArea) {
        return -1;
    }

    return 0;
};

export default function SummaryTab(props: IProps) {
    const historyContext = useContext(HistoryContext);
    const { t } = useTranslation("history");

    return (
        <>
            <Typography.Title level={4}>{t("yhteenvetoOtsikko")}</Typography.Title>
            <AreaByNotificationTypeContainer>
                <Typography.Title level={5}>{t("pintaAlaHehtaareina")}</Typography.Title>
                <p>{props.areaSizeInHectares && Math.round(props.areaSizeInHectares)}
                    {historyContext.areaToInspect === null && <span>{t("valitseEnsinAlue")}</span>}
                </p>

                <Typography.Title level={5}>{t("yhteenvetoNäkyvistäIlmoituksista")}</Typography.Title>
                <table>
                    <tbody>
                        <tr>
                            <StatisticsTableHeader><b>{t("taulukkoOtsikkoHakkuutyyppi")}</b></StatisticsTableHeader>
                            <StatisticsTableHeader><b>{t("taulukkoOtsikkoPintaAla")}</b></StatisticsTableHeader>
                            <StatisticsTableHeader><b>{t("taulukkoOtsikkoIkä")}</b></StatisticsTableHeader>
                        </tr>
                        {props.groupedStatistics && props.groupedStatistics.sort(sortingFn).map((f: any) => {
                            return <tr key={f.type}>
                                <td>{f.type}</td>
                                <td>{f.sumArea.toFixed(2)} ha</td>
                                <td>{f.avgAge ? f.avgAge.toFixed(2) : t("eiTietoaIästä")}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
                {historyContext.areaToInspect === null && <span>{t("valitseEnsinAlue")}</span>}
                {historyContext.areaToInspect && props.groupedStatistics && props.groupedStatistics.length === 0 && <span>{t("eiIlmoituksiaValitullaAjanhetkellä")}</span>}
            </AreaByNotificationTypeContainer>
        </>
    )
}